import { SecondaryButton } from "@stenajs-webui/elements";
import { ActionPrompt, Popover } from "@stenajs-webui/tooltip";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { refetchStatBoxesWithRateSheetsChanges } from "../../customer-route-statistic-boxes/thunks/RefetchStatBoxesWithRateSheetsChanges";
import { useResetForms } from "../hooks/UseResetForms";
import { routeAgreementOriginalSelectors } from "../redux/redux";
import { ZIndex } from "@/lib/utils/ZIndexEnum";

interface Props {
  disabled?: boolean;
  onDiscardChanges: () => void;
  dataTestid?: string;
}

export const RouteAgreementDiscardChangesButton: React.FC<Props> = ({
  disabled,
  onDiscardChanges,
  dataTestid,
}) => {
  const dispatch = useDispatch();
  const originalFormModel = useSelector(
    routeAgreementOriginalSelectors.getEntity
  );
  const { resetForms } = useResetForms(originalFormModel);

  const onYesHandler = () => {
    resetForms();
    onDiscardChanges();
    dispatch(refetchStatBoxesWithRateSheetsChanges());
  };

  return (
    <Popover
      zIndex={ZIndex.highest}
      appendTo={document.body}
      trigger={"click"}
      renderTrigger={(props) => (
        <SecondaryButton
          label={"Discard"}
          disabled={disabled}
          data-testid={dataTestid}
          {...props}
        />
      )}
    >
      {({ onRequestClose }) => (
        <ActionPrompt
          onNo={onRequestClose}
          onYes={() => {
            onRequestClose();
            onYesHandler();
          }}
        />
      )}
    </Popover>
  );
};
